// FT-217: запросы ценовых групп (CTR-02, CTR-03). Одно место на карточку машины,
// настройки, доску и виджет — авторизация как в соседнем коде (JWT из стора).
// vm — компонент: из него берутся axios и токен.
import { extractValidationDetail } from "@/mixins/setErrorMixin";

// Код отказа API групп: { error, code } или { error: { code } } — разбор
// extractValidationDetail; тело с одним { code } без error он не узнаёт, его
// берём напрямую.
export function priceGroupErrorCode(error) {
  const data = error && error.response && error.response.data;
  const code = extractValidationDetail(error).code;
  if (code) return code;
  return data && typeof data === "object" && typeof data.code === "string" ? data.code : null;
}

function auth(vm) {
  return { headers: { Authorization: vm.$store.getters.getAuthToken } };
}

// GET /api/v1/price_groups → { unit, groups: [{ id, min, max, cars_count }], drifted_count }
export function fetchPriceGroups(vm) {
  return vm.axios.get("/api/v1/price_groups", auth(vm)).then((r) => r.data || {});
}

// POST /api/v1/price_groups/rebuild { dry_run } → { groups_before, groups_after, cars_moved, applied }
export function rebuildPriceGroups(vm, { dryRun }) {
  return vm.axios
    .post("/api/v1/price_groups/rebuild", { dry_run: !!dryRun }, auth(vm))
    .then((r) => r.data || {});
}

// PATCH /api/v1/cars/:id/price_group — ровно одно из { price_group_id } | { new_group: true } | { ack: true }
// → { price_group_id, suggestion }
export function patchCarPriceGroup(vm, carId, body) {
  return vm.axios.patch(`/api/v1/cars/${carId}/price_group`, body, auth(vm)).then((r) => r.data || {});
}

// GET /api/v1/cars/:id/price_group → { price_group_id, suggestion, price_group, price_groups, unit }
// — перечитать группу и предложение машины после записи её цены (SC-04).
export function fetchCarPriceGroup(vm, carId) {
  return vm.axios.get(`/api/v1/cars/${carId}/price_group`, auth(vm)).then((r) => r.data || {});
}
